// extracted by mini-css-extract-plugin
module.exports = {"list":"Home2ConnectorsSection_list__wbDdc"};